<template>
  <div class="tr-test game-tr-multi-checkbox-impr" :style="getStyle()">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
    >
      <ps-text :font-size="`${isKatexFontSize}`" :text-value="`${item.text}`" v-if="isKatexFontSize"></ps-text>
      <ps-text :text-value="`${item.text}`" v-else></ps-text>
    </div>
    <div class="question-container" :style="getQuestionContainerStyle(startGameConfig.questionContainerStyle)">
      <div
        class="element-container"
        :class="[{ block: inputStatus(elementIndex) === 'correct' }]"
        v-for="(element, elementIndex) in dataItems"
        :key="'element_' + elementIndex"
        :id="'element_' + elementIndex"
        @click="resetCheckStatus"
        :style="getElementStyle(element)"
      >
        <mb-audio
          v-if="element.audioSrc"
          :item-audio="{ audioSrc: element.audioSrc, position: 'absolute', audioCss: element.audioCss }"
        ></mb-audio>
        <div class="item-container inner-element-container">
          <div class="">
            <label class="checkbox-container" :class="[{ block: selected['element_' + elementIndex].block }]">
              <div class="text-container">
                <ps-text :font-size="startGameConfig.gameFontSize" :text-value="element.text"></ps-text>
              </div>
              <tr-check-box
                :checkbox-data-model="selected['element_' + elementIndex]"
                :main-index="elementIndex"
                :index="elementIndex"
              ></tr-check-box>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import defaultMixin from '../../mixins/defaultMixin';
import selectGameMixin from '../../mixins/selectGameMixin';
import TrCheckBox from './TrCheckBox/TrCheckBox';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import PsText from '../TrInput/PsText';
export default {
  name: 'tr-multi-checkbox-impr',
  components: { TrCheckBox, MbAudio, PsText },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin, selectGameMixin],
  data() {
    return {
      katexFontSize: this.startGameConfig.katexFontSize,
      dataItems: {},
      textList: {},
      selected: [],
      staticText: [],
      imageData: {},
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.checkboxGamePrepareData();
      let selectedItem = _.take(this.dataItems);
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      }
      this.dataItems = this.flatttenItems(this.dataItems);
      _.each(this.dataItems, (item, elemIndex) => {
        this.selected = _.assign({}, this.selected, {
          ['element_' + elemIndex]: {
            correct: item.correct || false,
            value: false,
            block: false,
            status: 'rest',
          },
        });
      });
      console.log('this.selected', this.selected);
    },
    flatttenItems(elem) {
      let data = _.map(elem, (o) => {
        if (_.isArray(o.items)) {
          o.items = _.extend(o, o.items[0]);
          o = _.omit(o, ['items']);
        }
        return o;
      });
      return data;
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] === 'CORRECT') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    isText(obj) {
      return _.has(obj, 'text');
    },
    isImageInQuestionInQuestion(obj) {
      return _.some(obj.answers, 'imagePath');
    },
    selectRadioButto(qIndex, aIndex) {
      let element = this.$refs['question' + qIndex + 'answer' + aIndex];
      this.selected['element_' + qIndex] = element[0].value;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
    },
    checkGameAction() {
      console.log('this.selected', this.selected);
      let status = _.reduce(
        this.selected,
        (result, item, key) => {
          let temVal = null;
          if ((item.correct === true && item.value === true) || (item.correct === false && item.value === false)) {
            temVal = result && true;
            item.status = 'correct';
            item.block = item.value === true ? true : false;
          } else {
            temVal = false;
            item.status = 'incorrect';
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    getElementStyle(element) {
      element.offsetVertical = element.offsetVertical
        ? element.offsetVertical
        : this.startGameConfig.questionOffsetVertical;
      element.offsetHorizontal = element.offsetHorizontal
        ? element.offsetHorizontal
        : this.startGameConfig.questionOffsetHorizontal;
      element.width = element.width ? element.width : this.startGameConfig.questionWidth;
      element.height = element.height ? element.height : this.startGameConfig.questionHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: utils.elementWidth(element.width),
        height: utils.elementHeight(element.height),
      });
    },
    getStyle() {
      return _.merge(
        {
          position: 'absolute',
          'text-align': 'left',
          'font-size': this.gameFontSize,
        },
        this.getCustomStyle(this.startGameConfig),
        {
          display: this.startGameConfig.display || 'block',
          'flex-direction': this.startGameConfig.flexDirection || 'column',
          'overflow-x': this.startGameConfig.overflowX || 'auto',
          'overflow-y': this.startGameConfig.overflowY || 'auto',
          padding: this.startGameConfig.padding + '%',
          'margin-top': this.startGameConfig.marginTop + '%',
          'margin-left': this.startGameConfig.marginLeft + '%',
          'margin-bottom': this.startGameConfig.marginBottom + '%',
          'margin-right': this.startGameConfig.marginRight + '%',
        }
      );
    },
    getQuestionContainerStyle(style) {
      if (style) {
        return this.getCustomStyle({ cssStyle: style });
      }
      return;
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    isKatexFontSize() {
      if (this.katexFontSize) {
        return this.katexFontSize;
      } else {
        return null;
      }
    },
    processedQuestionsList() {
      return this.processQuestionsList();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1906px;
$backgroundHeight: 900px;
$backgroundOffsetTop: 140px;
$backgroundOffsetLeft: 0;
// .checkbox-container {
//     @media (min-width: 1200px) {
//         max-width: 97%;
//         width: 1780px;
//     }
// }
.game-tr-multi-checkbox-impr {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;

  .block {
    pointer-events: none;
  }
  .question-container {
    overflow-y: auto;
    overflow-x: hidden;
    height: inherit;
    width: inherit;
    position: absolute;
    top: 0;
    left: 0;
    .element-container {
      position: relative;
      display: block;

      .inner-element-container {
        display: block;

        width: 100%;
        height: 30%;
      }
      .item-container {
        display: flex;
        min-width: 22%;
        justify-content: flex-start;
        align-items: center;
        height: 49px;

        /* The checkbox-container */
        .checkbox-container {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: relative;
          height: 49px;
          padding-left: 60px;
          margin-bottom: 12px;
          cursor: pointer;
          // font-size: 22px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
        .block {
          pointer-events: none;
        }
        /* Hide the browser's default radio button */
        .checkbox-container input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
        }
      }
    }
  }

  .main-image-container {
    position: relative;
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
<style lang="scss">
$multiCheckboxColor: #f1f1f1;
.checkmark {
  background-color: $multiCheckboxColor;
}
</style>
